module.exports = __webpack_public_path__ + "media/images/bg-devise-d87ee1efd823c6d3283e4cc37e90800d.jpg";